import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import alertify from "alertifyjs";
import useFetchData from "../../hooks/useFetchData";
import { useTranslation } from "react-i18next";

// bütün verinin çekildiği, filtrelemenin ön yüzde yapıldığı dropdownlarda kullanılabilir.

const CommonFetchDropDownList = ({
  id,
  label,
  valueField,
  textField,
  extraField,
  onChange,
  fetchUrl,
  required,
  disabled,
  name,
  filterable = false,
}) => {
  const { data, loading, error } = useFetchData(fetchUrl);
  const [filter, setFilter] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const nameOrId = name || id;
  useEffect(() => {
    if (error) {
      alertify.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (filter) {
      const filtered = data.filter((item) => {
        const textMatch = item[valueField]
          .toLowerCase()
          .includes(filter.toLowerCase());
        const extraMatch = extraField
          ? item[extraField].toLowerCase().includes(filter.toLowerCase())
          : false;
        return textMatch || extraMatch;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [filter, data, valueField, extraField]);

  const handleFilterChange = (event) => {
    setFilter(event.filter.value); // Filtre değerini güncelle
  };

  const itemRender = (li, itemProps) => {
    var itemChildren = (
      <li className="k-list-item" style={{ display: "flex" }}>
        <span>{itemProps.dataItem[textField]} </span>
        {extraField && (
          <span style={{ marginLeft: "auto", fontWeight: 700 }}>
            &nbsp; {"(" + itemProps.dataItem[extraField] + ")"}
          </span>
        )}
      </li>
    );

    return React.cloneElement(li, li.props, itemChildren);
  };

  return (
    <DropDownList
      name={nameOrId}
      id={nameOrId}
      label={label ? label : undefined}
      style={{ width: "100%" }}
      data={filteredData}
      dataItemKey={valueField}
      textField={textField}
      itemRender={itemRender} // Özel öğe render işlevi
      // value={value ? data.find((v) => v[id] === value) : ""}
      onChange={onChange}
      loading={loading}
      required={required}
      disabled={disabled}
      filterable={filterable}
      onFilterChange={handleFilterChange}
    />
  );
};

export default CommonFetchDropDownList;

const CommonDropDownList = ({
  id,
  label,
  dataItemKey,
  textField,
  extraField,
  onChange,
  fetchUrl,
  required,
  disabled,
  name,
  filterable = false,
  value,
  data,
  ...rest
}) => {
  const { t } = useTranslation();
  const nameOrId = name || id;
  return (
    <DropDownList
      {...rest}
      name={nameOrId}
      id={nameOrId}
      value={value}
      label={label}
      style={{ width: "100%" }}
      data={data}
      dataItemKey={dataItemKey}
      textField={textField}
      defaultItem={{ text: t("choose"), value: null }}
      valid={required && rest.valid === undefined ? !!value : true}
      onChange={onChange}
      required={required}
      disabled={disabled}
      filterable={filterable}
    />
  );
};

export { CommonDropDownList };
